import React, { useEffect, useState } from 'react';
import { Transition } from 'react-transition-group';
import * as SS from '../styles/shared-styles';
import * as S from './style';
import OnboardingQuestionCarousal from './onboarding-questions-carousal';
import { GetSurveyDetailsData, GetOnboardingQuestions, SubmitSurvey } from '../../../services/loggedout-api';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { useDispatch, useSelector } from 'react-redux'
import { setQuestionOutcomeData, setSkipPersonalized } from '../../../stores/splashverse-onboarding/actions';
import { AGE_FIVE, AGE_THREE, EARLY_LEARNING_PROGRAM, ELEMENTARY_SCHOOL_PROGRAM, K_GRADE, PRE_K_GRADE } from '../../../constant-data/constants';
import { getCourseFromSubject } from '../helper/helper';
import { isNewCoqAssigned } from '../../../utils/feature_mapping';
import { SubmitOnboardingSurvey } from '../../../services/parent-api';

const OnboardingQuestions = ({
  isNextStep,
  goToNextHandler,
  currentStep,
  currentUser,
  students
}) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setAnimate(true);
    }, 100);
  }, [])

  return (
    <Transition in={animate} timeout={500}>
      {(state) => (
        <OnboardingQuestionComponent isNextStep={isNextStep} goToNextHandler={goToNextHandler} Tstate={state} currentStep={currentStep} currentUser={currentUser} students={students}/>
      )}
    </Transition>
  )
}

const OnboardingQuestionComponent = ({isNextStep, goToNextHandler, Tstate, currentStep, currentUser, students}) => {
  const { childScreenName, selectedGrade, svOnboardingEventParams, subjectCodeMap, gradeCodeMap, subjectGradeMap, isLPABTest} = useSelector(state => {
      return {
        childScreenName: state.childScreenName,
        selectedGrade: state.selectedGrade,
        svOnboardingEventParams: state.svOnboardingEventParams,
        subjectCodeMap: state.subjectCodeMap,
        gradeCodeMap: state.gradeCodeMap,
        subjectGradeMap: state.subjectGradeMap,
        isLPABTest: state.isLPABTest,
      }
    });

  const [onboardingQuestions, setOnboardingQuestions] = useState({});
  const [showDelayedTransition, setShowDelayedTransition] = useState(undefined);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [dataForQuestionsOutcome, setDataforQuestionOutcome] = useState([]);
  const [questionResponses, setQuestionResponses] = useState({});
  const isNewCoqAbTest = isNewCoqAssigned();

  const { getItem, setValue } = useExtendedLocalStorage('splashverse-onboarding', '');

  const dispatch = useDispatch();

  const selectedAge = getItem('selectedAge');

  const selectedProgram = getItem('selectedProgram');
  const studentId = getItem('childId');

  // If user select ELP flow then we are setting grade pk/k from our end
  let customSelectedGrade = selectedGrade;
  const useCustomSelectedGrade = selectedAge && selectedProgram && (selectedProgram == EARLY_LEARNING_PROGRAM);
  if(useCustomSelectedGrade) {
    customSelectedGrade = selectedAge == AGE_FIVE ? K_GRADE : PRE_K_GRADE;
  }

  const passAgeForPkAndK = (customSelectedGrade == PRE_K_GRADE) || (customSelectedGrade == K_GRADE);

  // If user select ESP flow then we are setting age for pk/k from our end -> pk - 3, k - 5
  let customSelectedAge = selectedAge;
  const useCustomSelectedAge = passAgeForPkAndK && (selectedProgram == ELEMENTARY_SCHOOL_PROGRAM);
  if(useCustomSelectedAge) {
    customSelectedAge = customSelectedGrade == PRE_K_GRADE ? AGE_THREE : AGE_FIVE;
  }

  const eventProperties = {
    Platform: 'Web',
    Subject: selectedSubject,
    Grade: useCustomSelectedGrade ? customSelectedGrade : selectedGrade,
  }

  useEffect(() => {
    setSelectedSubject(currentStep?.slice(21));
  }, [])

  useEffect(() => {
    if(selectedSubject) {
      doHeaderTransition();
      loadOnboardingQuestions();
    }
  }, [selectedSubject])

  const loadOnboardingQuestions = async () => {
    let params = {
      grade_code: useCustomSelectedGrade ? customSelectedGrade : selectedGrade,
    }
    if(isNewCoqAbTest) {
      params = { ...params, survey_code: 'coq', subject_code: selectedSubject };
    }
    if (subjectCodeMap.get('math') && gradeCodeMap.get(useCustomSelectedGrade ? customSelectedGrade : selectedGrade)) {
      let math = getCourseFromSubject(gradeCodeMap.get(useCustomSelectedGrade ? customSelectedGrade : selectedGrade).id, subjectCodeMap.get('math').id, subjectGradeMap);
      if (math) {
        params = { ...params, math_id: math.id };
      }
    }
    if (subjectCodeMap.get('ela') && gradeCodeMap.get(useCustomSelectedGrade ? customSelectedGrade : selectedGrade)) {
      let ela = getCourseFromSubject(gradeCodeMap.get(useCustomSelectedGrade ? customSelectedGrade : selectedGrade).id, subjectCodeMap.get('ela').id, subjectGradeMap);
      if (ela) {
        params = { ...params, ela_id: ela.id };
      }
    }

    if(passAgeForPkAndK) {
      params = { ...params, age: customSelectedAge };
    }

    let res;
    let data;
    if(isNewCoqAbTest) {
      res = await GetSurveyDetailsData(params);
      // data = res['coq_' + selectedSubject + '_' + customSelectedGrade + (passAgeForPkAndK ? ('_' + customSelectedAge) : '')];
      data = res['survey_questions'];
      setOnboardingQuestions(data);
    }
    else {
      res = await GetOnboardingQuestions(params, true);
      data = res['poq_' + selectedSubject + '_' + (useCustomSelectedGrade ? customSelectedGrade : selectedGrade)];
      setOnboardingQuestions(data);
    }

  }

  const onSkipPersonalizationHandler = async () => {
    let data = attachRestOfTheOutcomeDataAndIndex();
    questionEventHandler({
      'Clicked On': 'Skip Personalization'
    });
    if(Object.keys(questionResponses).length > 0) {
      isNewCoqAbTest ? SubmitSurvey({ survey_details: questionResponses, student_id: studentId, data_dump: true }, true) : SubmitOnboardingSurvey({ survey_details: questionResponses, data_dump: true }, true);
    }
    dispatch(setQuestionOutcomeData(data, selectedSubject));
    setValue('onboardingQuestionOutcome' + subjectCodeMap?.get(selectedSubject).title, data)
    dispatch(setSkipPersonalized(true));
    let opt = {
      selectedSubject
    }
    goToNextHandler(`onboarding_questions_${selectedSubject}`, opt);
  }

  const getCurrentIndexForQuestionOutcomeArr = (qid, arr) => arr.findIndex((q) => qid === q.key);

  const attachRestOfTheOutcomeDataAndIndex = () => {
    let restOfTheQuestions = dataForQuestionsOutcome;
    let practiceAndMasterIndex = 0, buildConceptIndex = 0;

    for (let i = 0; i <  Object.keys(onboardingQuestions).length; i++) {
      let questionKey = isNewCoqAbTest ? onboardingQuestions[i].code : Object.keys(onboardingQuestions)[i];
      let question = Object.values(onboardingQuestions)[i];
      let category = 'build_concepts';
      let indexOfAttemptedQuestion = getCurrentIndexForQuestionOutcomeArr(questionKey, restOfTheQuestions);

      if (!questionResponses[questionKey]) {
        restOfTheQuestions.push({
          key: questionKey,
          skill: question.skill_text,
          skillCount: question.skills_count,
          category,
          card: question.ordering,
          index: buildConceptIndex++,
          contentGroupCode: question.content_group,
          options: question.options,
          questionText: question.text
        })
      } else {
        if (restOfTheQuestions[indexOfAttemptedQuestion].category)
        restOfTheQuestions[indexOfAttemptedQuestion].index =
          restOfTheQuestions[indexOfAttemptedQuestion].category === 'practice_and_master' ?
            practiceAndMasterIndex++ :
            buildConceptIndex++
      }
    };
    return restOfTheQuestions;
  }

  const doHeaderTransition = () => {
    setShowDelayedTransition(false);
    setTimeout(() => {
      setShowDelayedTransition(true);
    }, 700);
  }

  const questionEventHandler = (data) => {
    const name = data.viewed ? 'Onboarding Question Screen Viewed' : 'Onboarding Question Interacted';
    const params = { ...data, ...eventProperties, ...svOnboardingEventParams.params };
    trackAnalyticsEvent(name, params);
  }
  const selectedSubjectObj = subjectCodeMap?.get(selectedSubject);
  const heading = isLPABTest ? `Great! Let's get to know ${childScreenName} a little better` : `Let’s build ${childScreenName}’s ${selectedSubjectObj && selectedSubjectObj.title} Learning Path`
  const subHeading = isLPABTest ? `We'll personalize ${childScreenName}'s learning experience based on this` : `Your responses will help us personalize ${childScreenName}’s learning experience better`

  return (
    selectedSubject &&
    <SS.OnboardingStepWrapper state={Tstate} isNextStep={isNextStep}>
      <S.Container>
        <S.HeaderContainer>
          <SS.StepHeader>
            {heading}
          </SS.StepHeader>
          <SS.StepSubheader>
            {subHeading}
          </SS.StepSubheader>
        </S.HeaderContainer>
        {onboardingQuestions && Object.keys(onboardingQuestions).length > 0 &&
          <OnboardingQuestionCarousal
            childScreenName={childScreenName}
            onboardingQuestions={onboardingQuestions}
            goToNextHandler={goToNextHandler}
            showTransition={showDelayedTransition}
            questionEventHandler={questionEventHandler}
            selectedSubject={selectedSubject}
            students={students}
            isLPABTest={isLPABTest}
            dataForQuestionsOutcome={dataForQuestionsOutcome}
            setDataforQuestionOutcome={setDataforQuestionOutcome}
            questionResponses={questionResponses}
            setQuestionResponses={setQuestionResponses}
            attachRestOfTheOutcomeDataAndIndex={attachRestOfTheOutcomeDataAndIndex}
            isNewCoqAbTest={isNewCoqAbTest}
            studentId={studentId}
          />
        }
        {!isLPABTest && <S.SkipPersonalisationCTA onClick={() => onSkipPersonalizationHandler()} showTransition={showDelayedTransition}>
          {`Skip personalization`}
        </S.SkipPersonalisationCTA> }
        <SS.Footer showTransition={showDelayedTransition}>
          {`Don't worry if you are unsure about a question. We will assess any gaps and adapt to ${childScreenName}'s skill level`}
        </SS.Footer>
      </S.Container>
    </SS.OnboardingStepWrapper>
  )
}

export default OnboardingQuestions;